import { useContext } from "react";
import { ApiContext } from "../../contexts/ApiContext";
import { useMutation } from "react-query";
import { QueryCallbacks } from "../../shared/interfaces/ReactQuery";

export function useSiteDelete(callbacks?: QueryCallbacks<null>) {
  const apiContext = useContext(ApiContext);
  return useMutation(["siteDelete"], async (siteId: number) => apiContext.siteApis.deleteSite(siteId), {
    onSuccess: callbacks?.onSuccess,
    onError: callbacks?.onError,
  });
}
